import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';

import { cn } from '@/services/utils';

const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-bg-muted tw-p-1 tw-text-muted-foreground',
            className
        )}
        {...props}
    />
));

TabsList.displayName = TabsPrimitive.List.displayName;

export { TabsList };
